/**
 * Where the HubSpot callback may send someone back to. Only a path on this
 * site: anything under /welcome/, in printable characters, or the dashboard
 * itself, exactly, which is where the free guide's Connect HubSpot step
 * starts from. Anything else lands on the HubSpot page as before.
 *
 * The callback builds a URL from this value, and building one resolves dots:
 * /welcome/../settings arrives as /settings, and so does its encoded form.
 * So a value with two dots, an encoded dot, or a doubled slash is refused
 * here, before it can climb out of /welcome/.
 */
export const HUBSPOT_RETURN_TO_KEY = 'hubspot_oauth_return_to'
export const HUBSPOT_MATCH_DOMAIN_KEY = 'hubspot_oauth_match_domain'

export function safeWelcomeReturnTo(value: string | null | undefined): string | null {
  if (!value) return null
  if (value === '/dashboard') return value
  if (!/^\/welcome\/[A-Za-z0-9_\-./?=&%+]*$/.test(value)) return null
  if (value.includes('..') || value.includes('//') || /%2e/i.test(value)) return null
  return value
}

/**
 * Connect from the dashboard and come back to it, matched to the site the
 * guide is about. One place builds this address: the guide's Connect HubSpot
 * step and the dashboard's wrong-account notice both go here.
 */
export function connectFromDashboard(domain: string | null): string {
  const params = new URLSearchParams({ returnTo: '/dashboard' })
  if (domain) params.set('matchDomain', domain)
  return `/hubspot/connect?${params.toString()}`
}
